<template>
  <div v-if="ready" class="c-main-container">

    <div class="back-link-container">
      <div class="back-link">
        <BackLink :to="{name: 'Home'}"/>
      </div>
    </div>

    <div class="main-container">

      <div class="item">
        <img src="/images/icn_smile.svg">
        <span class="head">Name</span>
        <span class="content">{{info.name}}</span>
      </div>
      <div class="item">
        <div><img src="/images/icn_paycoin.svg"></div>
        <div class="head">Total</div>
        <div class="content-pay">{{info.pay.pay}}<span class="pay">ペイ</span></div>
      </div>

      <div class="pay-operate-container">
        <div class="inner">
          <PayAdd :kidsId="info.id"/>
        </div>
        <div class="inner">
          <PayUse :kidsId="info.id"/>
        </div>
      </div>

      <div class="edit-container">
        <KidsEdit :info="info"/>
      </div>

      <hr class="hr">

      <div class="header-container">
        <span><img src="/images/icn_gift.svg"></span>
        <span class="contents">ご褒美・お約束</span>
        <span><img src="/images/icn_yubikiri.svg"></span>
      </div>

      <PromisesList :useEdit="false" @promiseSuccess="promiseSuccess"/>

    </div>

    <AdSense/>

    <div class="info-container">
      <div class="head">
        <img src="/images/icn_coins.svg"><span>獲得履歴</span>
      </div>
      <div v-if="Object.keys(info.log).length >= 1">
        <div v-for="(v,i) in info.log" :key="i">

          <div class="log">
            <span v-if="v.pay >= 1" class="head">獲得:</span>
            <span v-else class="head">利用:</span>
            <span class="date">{{v.date}}</span>
            <span class="pay">{{v.pay}}ペイ</span>
            <span class="note">{{v.note}}</span>
          </div>
        </div>

      </div>
      <div v-else class="no-logs">
        履歴はありません
      </div>

    </div>

    <div class="info-container">
      <div class="head">
        <img src="/images/icn_coin.svg"><span>ペイ履歴</span>
      </div>
      <div>
        獲得ペイ: {{info.pay.get}}ペイ
      </div>
      <div>
        利用ペイ: {{info.pay.use}}ペイ
      </div>
    </div>

    <div class="info-container">
      <div class="head">
        <img src="/images/icn_kids.svg"><span>キッズ専用ページ</span>
      </div>
      <div class="qrcode">
        <QRCodeGenerator :text="qrcodeText"/>
      </div>
      <div class="url-text">
        <a :href="qrcodeText" target="_blank">{{qrcodeText}}</a>
      </div>
    </div>

    <AdSense/>

    <div>
      <KidsUnregister :kidsId="info.id"/>
    </div>
  </div>
</template>

<script>

import QRCodeGenerator from '@/components/common/QRCodeGenerator';
import BackLink from '@/components/project/BackLink';
import KidsUnregister from '@/components/project/KidsUnregister';
import PayAdd from '@/components/project/PayAdd';
import PayUse from '@/components/project/PayUse';
import PromisesList from '@/components/project/PromisesList';
import KidsEdit from '@/components/project/KidsEdit';
import AdSense from '@/components/project/AdSense';

export default {
  components: {
    QRCodeGenerator,
    BackLink,
    KidsUnregister,
    PayAdd,
    PayUse,
    PromisesList,
    KidsEdit,
    AdSense,
  },
  data () {
    return {
      ready: false,
      store: 'kids',
      lock: false,
      info: {},
      code: '',
      qrcodeText: '',
      promise: null
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {

      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    },
    callbackDispatcher: function () {
      console.log(this.callbackDispatcher);

      if (this.callbackDispatcher === 'kidsUnregisterFinish') {
        // Homeへ遷移
        this.$router.push({name: 'Home'});
      } else if (this.callbackDispatcher === 'AddPaysFinish') {
        // リロード
        this.initialize();
      } else if (this.callbackDispatcher === 'UsePaysFinish') {
        // リロード
        this.initialize();
      } else if (this.callbackDispatcher === 'AddPromiseSuccessPay') {
        this.promiseDrivePay();
      } else if (this.callbackDispatcher === 'UsePromisePay') {
        this.promiseDrivePay();
      } else if (this.callbackDispatcher === 'KidsEditFinish') {
        this.initialize();
      }
    },
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    },
  },
  methods: {
    initialize: function () {
      console.log('initialize');

      this.getInfo();
    },
    getInfo: function () {
      console.log('getInfo');

      this.ready = false;

      if (this.lock) {
        console.log('lock', this.lock);
        return;
      }

      this.lock = true;

      this.code = this.$route.params.code;

      let param = {
        code: this.code,
        s: this.$store.getters['auth/session']
      };

      this.$store.dispatch(this.store + '/code2info', param).then(() => {

        let status = this.$store.getters[this.store + '/status'];
        // console.log(status);

        if (status === 200) {

          this.info = this.$store.getters[this.store + '/info'];
          console.log(this.info);

          this.qrcodeText = process.env.VUE_APP_URL + 'kids/' + this.info.code;

          this.ready = true;

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.log(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});

      });

    },
    moveToHome: function () {
      // ホームへ遷移
      this.$router.push({name: 'Home'});
    },
    promiseSuccess: function (promise) {
      console.log('promiseSuccess', promise);

      scrollTo(0, 0);

      this.promise = promise;

      let option;

      if (promise.type === 1) {

        option = {
          is2Button: true,
          buttonLabelL: 'ペイを付与',
          buttonLabelR: 'キャンセル',
          isButtonOnly: false,
          callbackL: 'AddPromiseSuccessPay',
          messages: ['"' + promise.title + '"の' + promise.pay + 'ペイを付与しますか？']
        };

      } else {

        option = {
          is2Button: true,
          buttonLabelL: 'ペイを使う',
          buttonLabelR: 'キャンセル',
          isButtonOnly: false,
          callbackL: 'UsePromisePay',
          messages: ['"' + promise.title + '"の' + promise.pay + 'ペイを使いますか？']
        };
      }

      // 確認ダイアログ
      this.$store.dispatch('message/open', option).then();

    },
    promiseDrivePay: function () {
      console.log('addPromiseSuccessPay', this.promise);

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = {
        pay: this.promise.pay,
        note: this.promise.title,
        kids_id: this.info.id,
        s: this.$store.getters['auth/session']
      };
      // console.log(params);

      // ロック
      this.lock = true;

      let dispatch;

      if (this.promise.type === 1) {
        dispatch = 'pays/add';

      } else {
        dispatch = 'pays/use';
      }

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters['pays/status'];

        if (status === 200) {

          let option;

          if (this.promise.type === 1) {
            option = {
              is1Button: true,
              buttonLabel: '確認',
              callback: 'AddPaysFinish',
              callbackO: 'AddPaysFinish',
              messages: [this.promise.pay + 'ペイを付与しました']
            };
          } else {
            option = {
              is1Button: true,
              buttonLabel: '確認',
              callback: 'UsePaysFinish',
              callbackO: 'UsePaysFinish',
              messages: [this.promise.pay + 'ペイを利用しました']
            };
          }

          // 確認ダイアログ
          this.$store.dispatch('message/open', option).then();

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', 'pays').then();
          this.$router.push({name: 'UserSystemError'});
        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    }
  }
};

</script>

<style lang="scss" scoped>

  .back-link-container {
    position: relative;

    .back-link {
      position: absolute;
      top: -40px;
      left: 25px;
    }
  }

  .main-container {

    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 10px;

    .item {
      width: 300px;
      margin: 10px auto;
      display: flex;
      align-items: center;

      .head {
        width: 55px;
        padding-left: 5px;
        font-size: 13px;
      }

      .content {
        font-weight: bold;
      }

      .content-pay {
        font-weight: bold;
        font-size: 18px;

        .pay {
          display: inline-block;
          padding-left: 5px;
          font-size: 12px;
          font-weight: normal;
        }
      }
    }

    .header-container {
      display: flex;
      align-items: center;
      margin-top: 15px;

      .contents {
        padding-left: 2px;
        padding-right: 2px;
      }
    }
  }

  .kids-info {
    text-align: center;
    font-size: 25px;
    border-bottom: 1px solid #ddd;
  }

  .pay-info {
    width: 300px;
    margin: 10px auto;
    border: 1px solid #ddd;
    border-radius: 20px;
    text-align: center;
    padding: 20px;

    .icon {
      font-size: 150px;
    }

    .text {
      font-size: 30px;
    }
  }

  .pay-operate-container {
    width: 300px;
    margin: 10px auto;
    display: flex;
    justify-content: center;

    .inner {
      margin: 10px 15px;
    }
  }

  .qrcode {
    text-align: center;
  }

  .info-container {
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin-top: 10px;
    margin-bottom: 10px;

    .head {
      display: flex;
      align-items: center;

      img {
        margin-right: 2px;
      }

    }
  }

  .log {
    font-size: 14px;

    .head {
      display: inline-block;
      width: 40px;
      padding-left: 5px;
    }

    .date {
      display: inline-block;
      width: 90px;
      padding-left: 5px;
    }

    .pay {
      display: inline-block;
      width: 70px;
      padding-left: 5px;
    }

    .note {
      padding-left: 5px;
    }

  }

  .no-logs {
    font-size: 14px;
  }

  .edit-container {
    text-align: right;
  }

  .hr {
    border: 0 solid #ddd;
    border-top-width: 1px;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .url-text {
      width: 95%;
      margin: 0 auto;
      text-align: center;
      font-size: 12px;
      word-wrap: break-word;
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .url-text {
      width: 95%;
      margin: 0 auto;
      text-align: center;
      font-size: 9px;
      word-wrap: break-word;
    }
  }

</style>
